import {Check, Copy} from 'lucide-react'
import { useState } from 'react'
import { isEthAddress, shortenAddress } from '@/lib/launchpad/contracts'

function TokenContractAddress({
  address,
  accent = 'lime',
  className = '',
}: {
  address?: string
  accent?: 'lime' | 'orange'
  className?: string
}) {
  const [copied, setCopied] = useState(false)

  if (!isEthAddress(address))
    return null

  const color = accent === 'lime'
    ? 'border-lime-400/30 bg-lime-400/10 text-lime-400 hover:border-lime-400/50'
    : 'border-orange-400/30 bg-orange-400/10 text-orange-400 hover:border-orange-400/50'

  async function copy() {
    try {
      await navigator.clipboard.writeText(address as string)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1600)
    }
    catch {
      setCopied(false)
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      title={copied ? 'Copied to clipboard' : address}
      aria-label="Copy Penguin Pad token contract address"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${color} ${className}`}
    >
      {copied
        ? <Check className="h-3.5 w-3.5" aria-hidden="true" />
        : <Copy className="h-3.5 w-3.5" aria-hidden="true" />}
      <span className="font-mono">
        CA:
        {' '}
        {shortenAddress(address)}
      </span>
      {copied ? <span>Copied</span> : null}
    </button>
  )
}

export default TokenContractAddress
